import Vue from 'vue';
import Component from 'vue-class-component';
import ApiProvider from "Api/ApiProvider";
import { ICustomerByEmail, IGetCustomersByEmailViewModel } from 'Api/CoreApi';
import { Watch, Prop } from 'vue-property-decorator';

@Component({})
export default class RecoverPasswordComponent extends Vue {

    loading: boolean = false;
    debounce: any = null;

    inputUsernameValue: string = null;
    hiddenUsernameValue: string = null;

    customers: ICustomerByEmail[] = [];
    selectedCustomer: ICustomerByEmail = null;

    get isCustomerSelected() {
        return this.selectedCustomer != null;
    }

    get isCustomerSelectNeeded() {
        return this.customers && this.customers.length > 0;
    }


    @Watch("inputUsernameValue")
    async onUsernameValueChange(e: any) {
        //if (!this.isUsernameValid()) return;
        this.hiddenUsernameValue = this.inputUsernameValue;

        clearTimeout(this.debounce);

        this.debounce = setTimeout(async () => {
            const client = ApiProvider.getApiClient();
            const response = await client.getCustomersByEmail(this.inputUsernameValue);
            this.customers = response.customers;
        }, 600);
    }

    isUsernameValid() {
        return this.inputUsernameValue && this.inputUsernameValue.length > 3;
    }

    onSubmit(e: any) {
        this.loading = true;

        if (!this.isUsernameValid()) {
            alert("Invalid username, please try again.");
            e.preventDefault();
            this.loading = false;
            return;
        }

        if (this.isCustomerSelectNeeded) {
            if (!this.isCustomerSelected) {
                alert("You need to select a customer.");
                e.preventDefault();
                this.loading = false;
                return;
            } else {
                this.hiddenUsernameValue = this.selectedCustomer.userName;
            }
        }

        this.loading = false;
    }
}
Vue.component('revover-form', RecoverPasswordComponent);